import { render, staticRenderFns } from "./Beacon.vue?vue&type=template&id=0e3b6808&"
import script from "./Beacon.vue?vue&type=script&lang=ts&"
export * from "./Beacon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports